import * as React from 'react';
import { Page } from '~/components/about-cob-page/about-cob-page';

const AboutCOBPage: React.FC = () => <Page />;

export default AboutCOBPage;
